 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}
 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"a4l~account~calendar~contacts~customers~dashboard~emails~events~groups~history~send~uploader":"a4l~account~calendar~contacts~customers~dashboard~emails~events~groups~history~send~uploader","a4l~account~calendar~contacts~customers~emails~events~groups~history~send~uploader":"a4l~account~calendar~contacts~customers~emails~events~groups~history~send~uploader","a4l":"a4l","account":"account","calendar~email~events":"calendar~email~events","calendar":"calendar","uploader":"uploader","contacts~customers~events~groups~history~org~send":"contacts~customers~events~groups~history~org~send","events":"events","send":"send","contacts~customers~groups~history":"contacts~customers~groups~history","contacts":"contacts","customers":"customers","groups":"groups","history":"history","emails":"emails","dashboard":"dashboard","about":"about","auth":"auth","email":"email","org":"org","forms":"forms"}[chunkId]||chunkId) + "." + {"a4l~account~calendar~contacts~customers~dashboard~emails~events~groups~history~send~uploader":"53a322bc","a4l~account~calendar~contacts~customers~emails~events~groups~history~send~uploader":"5d8bea1d","a4l":"483f30eb","account":"4f005806","calendar~email~events":"09198a37","calendar":"037dcb58","chunk-2d1326ae":"bba93bd2","chunk-84fc3392":"bf8fcce8","uploader":"35f8561f","contacts~customers~events~groups~history~org~send":"3bd825e0","events":"d81463cc","send":"bd42c7e2","contacts~customers~groups~history":"3da4db69","contacts":"68b8d67b","customers":"5b6d40e0","groups":"c5a489c6","history":"e505eeab","emails":"d1db996c","dashboard":"1b840533","about":"ead6445d","auth":"71e9f98b","email":"3467eb02","chunk-b31fb184":"cfe741f0","chunk-e6828aa8":"f5ad0de8","org":"349dc94e","forms":"5df327e7","chunk-26b3b24c":"91ff1e36","chunk-2d0b5e4f":"f0036831","chunk-f5ad7ae4":"0f958003","chunk-90fc1208":"6770cc37","chunk-2d0b8e57":"cc98ddef","chunk-2d0d3888":"9e1e81f7","chunk-7970c42b":"edd713a1","chunk-2d0c8273":"fe615974","chunk-4a32e0e2":"4f0ea9ba","chunk-4bd99be0":"43b9b37f"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"a4l~account~calendar~contacts~customers~dashboard~emails~events~groups~history~send~uploader":1,"a4l~account~calendar~contacts~customers~emails~events~groups~history~send~uploader":1,"a4l":1,"account":1,"calendar~email~events":1,"calendar":1,"chunk-84fc3392":1,"uploader":1,"contacts~customers~events~groups~history~org~send":1,"events":1,"send":1,"contacts":1,"customers":1,"history":1,"emails":1,"email":1,"chunk-b31fb184":1,"chunk-e6828aa8":1,"org":1,"forms":1,"chunk-26b3b24c":1,"chunk-f5ad7ae4":1,"chunk-90fc1208":1,"chunk-7970c42b":1,"chunk-4a32e0e2":1,"chunk-4bd99be0":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"a4l~account~calendar~contacts~customers~dashboard~emails~events~groups~history~send~uploader":"a4l~account~calendar~contacts~customers~dashboard~emails~events~groups~history~send~uploader","a4l~account~calendar~contacts~customers~emails~events~groups~history~send~uploader":"a4l~account~calendar~contacts~customers~emails~events~groups~history~send~uploader","a4l":"a4l","account":"account","calendar~email~events":"calendar~email~events","calendar":"calendar","uploader":"uploader","contacts~customers~events~groups~history~org~send":"contacts~customers~events~groups~history~org~send","events":"events","send":"send","contacts~customers~groups~history":"contacts~customers~groups~history","contacts":"contacts","customers":"customers","groups":"groups","history":"history","emails":"emails","dashboard":"dashboard","about":"about","auth":"auth","email":"email","org":"org","forms":"forms"}[chunkId]||chunkId) + "." + {"a4l~account~calendar~contacts~customers~dashboard~emails~events~groups~history~send~uploader":"c0e88e36","a4l~account~calendar~contacts~customers~emails~events~groups~history~send~uploader":"c9701dc7","a4l":"7d916833","account":"f1142744","calendar~email~events":"79d43159","calendar":"6032ee21","chunk-2d1326ae":"31d6cfe0","chunk-84fc3392":"2971cda8","uploader":"1d5c6732","contacts~customers~events~groups~history~org~send":"2f6fa252","events":"dd40c619","send":"98edd8e5","contacts~customers~groups~history":"31d6cfe0","contacts":"d855b009","customers":"66d81ba3","groups":"31d6cfe0","history":"c2f2d8d7","emails":"a7ca30f5","dashboard":"31d6cfe0","about":"31d6cfe0","auth":"31d6cfe0","email":"86cf5117","chunk-b31fb184":"e53683ca","chunk-e6828aa8":"6f2a346f","org":"9eae8ab4","forms":"2f6fa252","chunk-26b3b24c":"7fa39417","chunk-2d0b5e4f":"31d6cfe0","chunk-f5ad7ae4":"911446af","chunk-90fc1208":"3867894e","chunk-2d0b8e57":"31d6cfe0","chunk-2d0d3888":"31d6cfe0","chunk-7970c42b":"6bff7054","chunk-2d0c8273":"31d6cfe0","chunk-4a32e0e2":"45402333","chunk-4bd99be0":"d44717b7"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							var error = new Error('Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')');
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
